export const NAME_VALIDATION = {
  minLength: 3,
  maxLength: 50,
  pattern: /^[a-zA-Z0-9-_ ]+$/,
} as const

export interface NameValidationResult {
  readonly isValid: boolean
  readonly error: string | null
}

export function validateName(value: string, fieldName: string): NameValidationResult {
  const trimmed = value.trim()

  if (!trimmed) {
    return { isValid: false, error: `${fieldName} is required` }
  }

  if (trimmed.length < NAME_VALIDATION.minLength) {
    return {
      isValid: false,
      error: `${fieldName} must be at least ${NAME_VALIDATION.minLength} characters`,
    }
  }

  if (trimmed.length > NAME_VALIDATION.maxLength) {
    return {
      isValid: false,
      error: `${fieldName} must be at most ${NAME_VALIDATION.maxLength} characters`,
    }
  }

  if (!NAME_VALIDATION.pattern.test(trimmed)) {
    return {
      isValid: false,
      error: `${fieldName} can only contain letters, numbers, spaces, hyphens, and underscores`,
    }
  }

  return { isValid: true, error: null }
}
